// removed by extract-text-webpack-plugin
module.exports = {"debugButton":"_2gLMD","wrapper":"_Zvde","controls":"_2dbFT","controlsHidden":"qnItg _2dbFT","bar":"_2frap","topBar":"_3hG7G _2frap","bottomBar":"Z6CS0 _2frap","button":"_3zeWB","controlButton":"_1XUa4 _3zeWB","progress":"_22fji","settingsButton":"G-buD _3zeWB","settingsButtonCorner":"_1NOiL G-buD _3zeWB","closeButton":"_3vM_8 _3zeWB","tools":"aqCrm","stars":"_6vlqm","info":"_3q521","imageInfoOverlay":"_2zm9Y","imageInfo":"_3zr5s","infoButton":"_3tcNq _2gLMD","debugModal":"_30hDQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/Presentation.css
// module id = 840
// module chunks = 0